import config from './config'

export default {
    config,
    theme: {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/FordLegacy/index.js